import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { MoralisProvider } from "react-moralis";


const root = ReactDOM.createRoot(document.getElementById('root'));
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDn6MAPBAfFhc-5OVkdXgSe4GNeb2990Eo",
    authDomain: "cannypixelsclub.firebaseapp.com",
    projectId: "cannypixelsclub",
    storageBucket: "cannypixelsclub.appspot.com",
    messagingSenderId: "578620142539",
    appId: "1:578620142539:web:40a40ceaaf052196f9bc4e",
    measurementId: "G-V3QF1S045G"
  };
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

root.render(
    <React.StrictMode>
        <MoralisProvider serverUrl='https://mudpxrc9r7nu.usemoralis.com:2053/server' appId='ZgeBDdTDjdysxDE7QuP8y5RZe3CFqR0rg8XxFeMt'>
            <App />
        </MoralisProvider>
    </React.StrictMode>
);
